import {
  ReactElement, useEffect, useRef, useState,
} from 'react';
import { createPortal } from 'react-dom';

// Interfaces
interface IPortal {
  children: ReactElement | ReactElement[] | null,
  selector: string,
}

// Component
const Portal = (props: IPortal) => {
  const { children, selector } = props;

  const [mounted, setMounted] = useState(false);

  const ref = useRef<any>(null);

  useEffect(() => {
    ref.current = document.querySelector(`#${selector}`);
    setMounted(true);
  }, [selector]);

  return mounted ? createPortal(children, ref.current) : null;
};

export default Portal;
